import type { OrganizationFeature } from "../models/organization-feature";

/** Each optional page's route. */
const FEATURE_ROUTES: Readonly<Record<OrganizationFeature, string>> = {
  activity: "/activity",
  documents: "/documents",
};

/**
 * The optional page `url` is on, if the organization has switched it off —
 * or undefined. Matches the page and anything under it, query string
 * included, but not a different route that merely starts the same way.
 */
export function switchedOffPageAt(
  url: string,
  isOn: (feature: OrganizationFeature) => boolean
): OrganizationFeature | undefined {
  const path: string = url.split(/[?#]/)[0] ?? url;
  return (Object.keys(FEATURE_ROUTES) as OrganizationFeature[]).find(
    (feature: OrganizationFeature): boolean => {
      const route: string = FEATURE_ROUTES[feature];
      return (path === route || path.startsWith(`${route}/`)) && !isOn(feature);
    }
  );
}
